















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Mutation, State } from 'vuex-class';
import { RootState } from '@/store/types';
import Store from '@/store/store';
import session from '@/session';
import { User } from '@/store/login/types';

const namespace: string = 'login';

@Component
export default class SideBar extends Vue {
  @Action('logout', { namespace }) private logout?: () => void;
  @State('menuVisible') private menuVisible: boolean;
  @Mutation('toggleMenu') private toggleMenu: () => void;

  user: User = {};

  private mounted() {
    this.user = JSON.parse(session.get() || '');
  }

  get isAdmin() {
    let admin = JSON.parse(session.get() || '');
    return 'ADMIN' === admin.profile;
  }
}
